<template>
  <div>
    <v-btn-toggle v-model="localActiveTab" class="tabs" mandatory>
      <v-btn v-for="(tab, i) in tabs" :text="localActiveTab !== i" :key="`tab-${i}`" :data-test="`tab ${tab}`">
        <span :class="{ 'font-weight-bold': localActiveTab === i }">{{ tab }}</span>
      </v-btn>
    </v-btn-toggle>
    <v-card class="no-radius">
      <slot/>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    /**
     * The list of tabs (array of tab names)
     */
    tabs: Array,
    /**
     * The index of the current tab
     */
    activeTab: Number
  },
  data () {
    return {
      localActiveTab: null
    }
  },
  watch: {
    localActiveTab (newValue) {
      this.$emit('update:activeTab', newValue)
    },
    activeTab (newValue) {
      this.localActiveTab = newValue
    }
  }
}
</script>

<style lang="sass">
.no-radius
  border-radius: 0 !important

  table
    border-radius: 0 !important

  & > nav
    border-radius: 0 !important

.tabs
  box-shadow: none
  border-radius: 0 !important

  .v-btn, .v-btn:before, .v-btn:hover:before, .v-btn:focus:before
    background-color: white !important
    border-radius: 0 !important
</style>
